import React, { useEffect, useReducer, useState } from 'react';
import {
  SurveyDetailAcvivateButton,
  SurveyDetailContainer,
  SurveyDetailWrapper,
  SurveyDetailContent,
  SurveyDetailHeader,
  SurveyDetailHaderTitle,
  SurveyDetailHaderGrid,
  SurveyDetailSelectContainer,
  SurveyDetailSelectShowOptionSelect,
  SurveyDetailSelectShowOptionSelected,
  SurveyDetailSelectShowOptionContent,
  SurveyDetailSelectShowOptionSelectOption,
  SurveyDetailSelectShowOptionSelectedMessageError,
  SurveyDetailSelectLabel,
  SurveyDetailSelectActiveOption,
  SurveyHeaderIcon,
  SurveyMainDetail,
  SurveyBoxDetail,
  SurveyDetailBodyLabel,
  SurveyDetailBodyValue,
  SurveyDetailBodyGrid,
  SurveyBoxDetailContent,
  SurveyDetailHeaderGrid,
  SurveyDetailBodyLine,
  SurveyDetailSubTitle,
  SurveyDetailFinishedContent,
  SurveyDetailHalfBox
} from './styles';
import { H4 } from '../../components/Typography/styles';
import { BsPersonCheck, BsChevronDown } from 'react-icons/bs';
import { BsInfo } from 'react-icons/bs';
import ModalAction from '../../components/ModalAction'; import Copyright from '../../components/Copyright';
import colors from '../../assets/styles/colors';
import FormSteps from '../../components/FormSteps';
import Loader from '../../components/Loader';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import { default as SurveyDetailTypes } from '../../store/Simulator/types';
import { formatPhone } from '../../helpers/string';
import { formatData, formatDateToDefaultUS } from '../../helpers/date';
import { formatPrice } from '../../helpers/price';
import { getAnswersById } from '../../services/survey';
import { DefaultLargeButton, SecondaryLargeButton , TertiaryLargeButton, DefaultSmallButton} from '../../components/Buttons/styles';
import { updateQuestion } from '../../services/survey';
const SurveyDetail = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [answers, setAnswers] = useState([]);
  const [detail, setDetail] = useState();
  const [answerError, setAnswerError] = useState(false);
  const [average, setAverage] = useState(0);
  const [medium, SetMedium] = useState(0);
  const [mediumCounter, setMediumCounter] = useState(0);
  const [maximum, setMaximum] = useState(10);
  const [minimum, setMinimum] = useState(0);

  const history = useHistory();

  async function initializedStateComponent() {
    try {
      if (location.state) {
        await setDetail(location.state);
      }
      else{history.push('admin/survey');}

      if(!location.state)
      {
        setAnswerError(true);
      }
      else{
        const auxAnswers = await getAnswersById(location.state.id);
        await setMaximum(location.state.valorMaximo);
        await setMinimum(location.state.valorMinimo);
        await setAnswers(auxAnswers.data);
        var averageAux = 0;
        var answerCount = 0;
        await auxAnswers.data.forEach((element, index) => {
          //set average
          averageAux += parseInt(element.cantidad) * parseInt(element.respuesta);
          //set medium
          if(parseInt(element.cantidad) > mediumCounter){
            setMediumCounter(parseInt(element.cantidad));
            SetMedium(parseInt(element.respuesta));
          }
          //set answer counter
          answerCount += parseInt(element.cantidad);
          
        });

        if (answerCount != 0){setAverage(averageAux/answerCount);}

      }

      setIsLoading(false);
    } catch (error) {
      console.log(error)
    }
  }
  function changeActivation(){
    setIsLoading(true);
    const send = {
      id: detail.id,
      activo: !detail.activo
    }
    updateQuestion(detail.id, send);
    history.push('survey');
  }

  useEffect(() => {
    initializedStateComponent();
  }, []);

  return (
    <SurveyDetailContainer id="survey-detail-page">
      <SurveyDetailWrapper>
        {(isLoading && !answerError) ? <Loader /> : (
          <SurveyDetailContent>
            <SurveyDetailHeader>
            <SurveyDetailHeaderGrid>
                <SurveyMainDetail>
                  {location.state.id}<br />
                  {location.state.pregunta}
                </SurveyMainDetail>
              </SurveyDetailHeaderGrid>
              <SurveyBoxDetailContent>
                <SurveyDetailBodyLine>Respuestas:</SurveyDetailBodyLine>
                {answers.map((item,key) =>(
                  <SurveyDetailBodyLine key={key}>
                    <SurveyDetailBodyLabel>{item.respuesta}: </SurveyDetailBodyLabel>
                    <SurveyDetailBodyValue>{item.cantidad}</SurveyDetailBodyValue>
                  </SurveyDetailBodyLine>  
                ))}
              </SurveyBoxDetailContent>
              <SurveyDetailFinishedContent>
                <SurveyDetailBodyLine>
                  <SurveyDetailHalfBox>
                    Promedio de Puntaje:<br/>
                    {average}
                  </SurveyDetailHalfBox>
                  <SurveyDetailHalfBox>
                    Media de puntaje:<br/>
                    {medium}
                  </SurveyDetailHalfBox>
                </SurveyDetailBodyLine>
                <SurveyDetailBodyLine>
                  <SurveyDetailHalfBox>
                    Valor minimo:<br/>
                    {minimum}
                  </SurveyDetailHalfBox>
                  <SurveyDetailHalfBox>
                    Valor maximo:<br/>
                    {maximum}
                  </SurveyDetailHalfBox>
                </SurveyDetailBodyLine>
              </SurveyDetailFinishedContent>
            </SurveyDetailHeader>
          </SurveyDetailContent>
        )}
        {answerError && 

        <SurveyDetailContent>
          No se encontraron respuestas
        </SurveyDetailContent>}
        <SurveyDetailAcvivateButton>
          <DefaultSmallButton type="button" id="alterar-active" onClick={() => changeActivation()}>{location.state.activo ? "desactivar" : "activar"}</DefaultSmallButton>
        </SurveyDetailAcvivateButton>
      </SurveyDetailWrapper>
      <Copyright />
    </SurveyDetailContainer>
  )
}

export default SurveyDetail;
